module.exports = __webpack_public_path__ + "img/pic_xiyiye1.4a28fad3.png";